import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-career-guidance', templateUrl: './career-guidance.component.html', styleUrls: ['./career-guidance.component.scss'] })
export class CareerGuidanceComponent implements OnInit { constructor() { } ngOnInit(): void { } }
